module.exports = __webpack_public_path__ + "static/media/P20-thumb-wheel.2db254a4.svg";